export default class Tooltip {
    constructor() {
        if (typeof window.globalWordExplanation === 'undefined') {
            return;
        }

        const wordExplanation = window.globalWordExplanation;
        const tags = document.querySelectorAll('.transportfactssubjectpage .rich-text p:not([class]), .membership-application__form-container *');

        tags.forEach(tag => this.processTextNodes(tag, wordExplanation));

        document.querySelectorAll('.tooltip').forEach(tooltip => {
            tooltip.addEventListener('focus', (e) => this.setAriaHidden(e, false), true);
            tooltip.addEventListener('mouseover', (e) => this.setAriaHidden(e, false));
            tooltip.addEventListener('blur', (e) => this.setAriaHidden(e, true), true);
            tooltip.addEventListener('mouseleave', (e) => this.setAriaHidden(e, true));
        });
    }

    processTextNodes(element, wordExplanation) {
        let nodesToModify = [];
        let walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);

        let node;
        while ((node = walker.nextNode())) {
            if (node.parentNode.closest('.tooltip'))
                continue;

            let text = node.nodeValue;
            let originalText = text;

            wordExplanation.forEach(item => {
                const escapedWord = item.Word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const safeId = item.Word.replace(/\s+/g, '-');

                const expression = new RegExp(`(^|\\s)(${escapedWord})(?=\\s|$)`, 'gi');

                text = text.replace(expression, (match, p1, p2) => {
                    return `${p1}<span tabindex="0" class="tooltip" role="button" aria-describedby="tooltip-${safeId}">${p2}<span role="tooltip" id="tooltip-${safeId}" class="tooltip__tip" aria-hidden="true"><strong>${item.Word}</strong>${item.Explanation}</span></span>`;
                });
            });

            if (text !== originalText) {
                nodesToModify.push({ node, text });
            }
        }

        nodesToModify.forEach(({ node, text }) => {
            const tempElement = document.createElement('span');
            tempElement.innerHTML = text;
            node.replaceWith(...tempElement.childNodes);
        });
    }

    setAriaHidden(e, isHidden) {
        const tooltip = e.target.closest('.tooltip');
        const tip = tooltip.querySelector('.tooltip__tip');
        if (tip) {
            tip.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
        }
    }
}

document.addEventListener("DOMContentLoaded", () => new Tooltip());
